import { Box, Button, Chip } from '@mui/material';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Query } from '@/components/atoms/query';
import { BillingGroup } from '@/features/billing-groups/api/types/billing-group';
import { DestinationGroup } from '@/features/destination-groups/api/types/destination-group';

interface HostFiltersProps {
  query: string;
  handleChangeQuery: (query: string) => void;
  handleOpenFilterByDestinationGroup: () => void;
  handleOpenFilterByBillingGroup: () => void;
  selectedSearchBillingGroup: BillingGroup | null;
  selectedSearchDestinationGroup: DestinationGroup | null;
  setSelectedSearchBillingGroup: Dispatch<SetStateAction<BillingGroup | null>>;
  setSelectedSearchDestinationGroup: Dispatch<SetStateAction<DestinationGroup | null>>;
}

const HostFilters: FC<HostFiltersProps> = props => {
  const {
    query,
    handleChangeQuery,
    handleOpenFilterByDestinationGroup,
    handleOpenFilterByBillingGroup,
    selectedSearchBillingGroup,
    selectedSearchDestinationGroup,
    setSelectedSearchBillingGroup,
    setSelectedSearchDestinationGroup,
  } = props;

  const { t } = useTranslation(['host']);

  return (
    <>
      <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 1, pb: 2 }}>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Query
            searchAsType
            placeholder={t('host:searchEmail')}
            disabled={false}
            onChange={newQuery => {
              handleChangeQuery(newQuery);
            }}
            value={query}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 2,
              flex: 1.1,
            }}>
            <Button
              variant="contained"
              sx={{
                width: 'max-content',
              }}
              onClick={handleOpenFilterByDestinationGroup}>
              {t('host:filterByDestinationGroup.destinations')}
            </Button>
            <Button
              variant="contained"
              onClick={handleOpenFilterByBillingGroup}
              sx={{
                width: 'max-content',
              }}>
              {t('host:filterByBillingGroup.destinations')}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}>
          {selectedSearchBillingGroup ? (
            <Chip
              label={t('host:filterByBillingGroup.chip') + selectedSearchBillingGroup?.name}
              onDelete={() => {
                setSelectedSearchBillingGroup(null);
              }}
              color="primary"
            />
          ) : null}
          {selectedSearchDestinationGroup ? (
            <Chip
              onDelete={() => {
                setSelectedSearchDestinationGroup(null);
              }}
              label={t('host:filterByDestinationGroup.chip') + selectedSearchDestinationGroup?.name}
              color="primary"
            />
          ) : null}
        </Box>
      </Box>
    </>
  );
};

export default HostFilters;
